import { getApiGatewayDomain } from "@nova/fetch-api-gateway"
import { CogOrtho, SatelliteFlight } from "@nova/protobuf"

export const getSatelliteFlightTileUrl = (
    flight: SatelliteFlight,
    cogOrtho: CogOrtho,
    orgId: string,
    projectId: string,
    opacity = 1
) => {
    const options: Record<string, string> = {
        source: "satellite",
        cogId: cogOrtho.fileId,
        opacity: opacity.toString(),
    }
    if (flight.demoId) options.isDemo = "true"
    const query = new URLSearchParams(options).toString()
    return `${getApiGatewayDomain()}/org/${orgId}/project/${projectId}/flight/${flight.demoId || flight.id}/tile/%7Bz%7D/%7Bx%7D/%7By%7D?${query}`
}
